/// only for webpack build. not for react app.

import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { Yubinuki } from './components/Yubinuki';

let yubinuki: Yubinuki = {
    koma: 8,
    tobi: 2,
    resolutionAuto: false,
    resolution: 10,
    needleMode: 1,
    procedures:[
        {
            groupNo: 0,
            matomeSasi: false,
            sasiType: 0,
            itos:[
                { rounds: 0, color: '808080' }
            ],
            connectedRounds: 1,
            offset: 0,
        },
        {
            groupNo: 0,
            matomeSasi: false,
            sasiType: 0,
            itos:[
                { rounds: 0, color: 'ff0000' },
                { rounds: 0, color: 'fffe00' },
            ],
            connectedRounds: 1,
            offset: 1,
        }
    ],
};

ReactDOM.render(<App yubinuki={yubinuki} />, document.getElementById('root'));
